/** Preferința de durată sesiune, persistată în localStorage (non-sensitive). */
import type { SessionLifetime } from '@/api/auth';

const KEY = 'cerbes-session-lifetime';
const ALLOWED = new Set<number>([10, 15, 30, 60, 90, 120]);
const DEFAULT: SessionLifetime = 30;

export function readSessionLifetime(): SessionLifetime {
  if (typeof localStorage === 'undefined') return DEFAULT;
  const v = Number(localStorage.getItem(KEY));
  return (ALLOWED.has(v) ? v : DEFAULT) as SessionLifetime;
}

export function writeSessionLifetime(value: SessionLifetime): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(KEY, String(value));
}
